<template>
    <new-modal
        ref="updateCardInformationModal"
        :show-header="false"
        :show-close-x="false"
        :close-on-bg-click="false"
        v-on:modal-opened="initForm"
        v-on:modal-closed="cancelSetupIntent"
    >
        <template #trigger>
            <div
                class="rounded border border-primary-525 px-3 py-2 text-primary-525 hover:cursor-pointer"
            >
                Update payment method
            </div>
        </template>
        <template #content>
            <div
                class="flex flex-col items-center justify-center gap-8 py-8"
                v-if="loadingForm"
            >
                <div class="">
                    <div class="animate animate-spin">
                        <svg
                            width="64"
                            height="63"
                            viewBox="0 0 64 63"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M63.5 31.5C63.5 48.897 49.397 63 32 63C14.603 63 0.5 48.897 0.5 31.5C0.5 14.103 14.603 0 32 0C49.397 0 63.5 14.103 63.5 31.5ZM8.26209 31.5C8.26209 44.6101 18.8899 55.2379 32 55.2379C45.1101 55.2379 55.7379 44.6101 55.7379 31.5C55.7379 18.3899 45.1101 7.76209 32 7.76209C18.8899 7.76209 8.26209 18.3899 8.26209 31.5Z"
                                fill="#DDE1EA"
                            />
                            <path
                                d="M32 2.43779e-06C25.7699 2.71012e-06 19.6797 1.84745 14.4995 5.30871C9.31939 8.76997 5.28195 13.6896 2.89779 19.4455C0.513633 25.2013 -0.110172 31.5349 1.10526 37.6453C2.3207 43.7557 5.32078 49.3685 9.72614 53.7739C14.1315 58.1792 19.7443 61.1793 25.8547 62.3947C31.9651 63.6102 38.2987 62.9864 44.0545 60.6022C49.8104 58.218 54.73 54.1806 58.1913 49.0005C61.6526 43.8203 63.5 37.7301 63.5 31.5L55.7379 31.5C55.7379 36.1949 54.3457 40.7844 51.7374 44.6881C49.129 48.5918 45.4216 51.6343 41.0841 53.431C36.7466 55.2276 31.9737 55.6977 27.369 54.7818C22.7643 53.8659 18.5346 51.605 15.2148 48.2852C11.895 44.9654 9.63414 40.7357 8.71821 36.131C7.80227 31.5263 8.27236 26.7534 10.069 22.4159C11.8657 18.0784 14.9082 14.371 18.8119 11.7626C22.7156 9.15429 27.3051 7.76209 32 7.76209L32 2.43779e-06Z"
                                fill="#0685BB"
                            />
                        </svg>
                    </div>
                </div>
                <div class="">Loading secure payment form...</div>
            </div>
            <div class="flex flex-col gap-4" v-show="!loadingForm">
                <div class="">
                    <form @submit.prevent="submitForm" id="payment-form">
                        <div
                            v-if="paymentError"
                            class="mt-4 rounded bg-danger-light p-2 text-[14px] font-semibold text-danger-darker"
                        >
                            {{ paymentError }}
                        </div>

                        <div
                            id="payment-element"
                            class="bg-center bg-no-repeat"
                        >
                            <!-- Elements will create form elements here -->
                        </div>
                    </form>
                </div>
                <div class="flex justify-end gap-4">
                    <span class="btn btn-outline" @click="cancel">Cancel</span>
                    <button
                        @click="submitForm"
                        v-if="!submittingCardInfo"
                        class="btn btn-primary"
                    >
                        Update Card
                    </button>
                    <span v-else class="btn btn-secondary opacity-50">
                        Please wait, updating card info...
                    </span>
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
const stripe = Stripe(window.stripeKey);

import NewModal from "@/Components/NewModal.vue";

export default {
    name: "StudentUpdatePaymentMethodModal",
    components: { NewModal },
    data() {
        return {
            loadingForm: true,
            user: this.$page.props.auth.user,
            cardInfo: this.$page.props.auth.user.stripe_card_meta,
            stripePublicKey: window.stripeKey,
            stripeToken: null,
            paymentError: null,
            stripElements: null,
            cardElement: null,
            stripeSetupIntentId: null,
            stripeSetupIntentClientSecret: null,
            submittingCardInfo: false,
            form: this.$inertia.form({
                billingEmail: this.$page.props.auth.user.email,
                billingFullName:
                    this.$page.props.auth.user.first_name +
                    " " +
                    this.$page.props.auth.user.last_name,
                billingStreet: null,
                billingCity: this.$page.props.auth.user.city,
                billingState: this.$page.props.auth.user.state,
                billingPostalCode: null,
            }),
        };
    },
    methods: {
        cancel() {
            this.$refs.updateCardInformationModal.closeModal();
        },
        cancelSetupIntent() {
            axios
                .get(
                    route("cancel-update-payment-method-setup-intent", {
                        setup_intent_id: this.stripeSetupIntentId,
                    })
                )
                .then(function (response) {
                    console.log(response);
                });
        },
        initForm() {
            let vm = this;

            axios
                .get(route("prepare-update-payment-method"))
                .then(function (response) {
                    vm.stripeSetupIntentClientSecret =
                        response.data.setup_intent_client_secret;
                    vm.stripeSetupIntentId = response.data.setup_intent;
                    vm.setupPaymentElement();

                    setTimeout(function () {
                        vm.loadingForm = false;
                    }, 1000);
                });
        },
        setupPaymentElement() {
            let vm = this;
            let stripeOptions = {
                clientSecret: vm.stripeSetupIntentClientSecret,
                appearance: {
                    theme: "stripe",
                    labels: "above",
                    variables: {
                        colorPrimary: "#0D7AD9",
                        colorBackground: "#F2F0F0",
                        colorText: "#343434",
                        colorDanger: "#df1b41",
                        fontFamily: "Ideal Sans, system-ui, sans-serif",
                        spacingUnit: "2px",
                        borderRadius: "3px",
                        fontSizeBase: "18px",
                        spacingGridColumn: "16px",
                        spacingGridRow: "16px",
                    },
                    rules: {
                        ".Label": {
                            fontWeight: 600,
                        },
                        ".Label--resting": {
                            color: "#8C969C",
                        },
                        ".Label--floating": {
                            color: "#8C969C",
                            fontSize: "12px",
                        },
                        ".Input": {
                            color: "#121212",
                            padding: ".5rem",
                            paddingLeft: ".75rem",
                        },
                        ".Error": {
                            fontSize: "14px",
                        },
                    },
                },
            };
            this.stripElements = stripe.elements(stripeOptions);
            this.paymentElement = this.stripElements.create("payment");
            this.paymentElement.mount("#payment-element");
        },
        submitForm() {
            let vm = this;

            if (this.submittingCardInfo) {
                return;
            } else {
                this.submittingCardInfo = true;
            }

            this.confirmSetup().then(function (result) {
                if (result.error) {
                    if (
                        result.error.type === "card_error" ||
                        result.error.type === "validation_error"
                    ) {
                        vm.paymentError = result.error.message;
                    } else {
                        vm.paymentError =
                            "An unexpected error occurred. Please try again later.";
                    }
                }

                vm.submittingPayment = false;
            });
        },
        async confirmSetup() {
            let confirmParams = {
                payment_method_data: {
                    billing_details: {
                        name: this.user.first_name + " " + this.user.last_name,
                        email: this.user.email,
                        phone: null,
                        postal_code: null,
                        address: {
                            line1: this.form.billingStreet,
                            city: this.form.billingCity,
                            state: this.form.billingState,
                            postal_code: this.form.billingPostalCode,
                            country: "US",
                        },
                    },
                },
                return_url:
                    window.siteDomain +
                    "/finalize-update-payment-method/" +
                    this.user.id,
            };

            if (this.showAdditionalBillingFields) {
                confirmParams.shipping = {
                    name: this.user.first_name + " " + this.user.last_name,
                    address: {
                        line1: this.form.billingStreet,
                        city: this.form.billingCity,
                        state: this.form.billingState,
                        postal_code: this.form.billingPostalCode,
                        country: "US",
                    },
                };
            }

            let elements = this.stripElements;

            let result = stripe.confirmSetup({
                elements,
                confirmParams: confirmParams,
            });

            return result;
        },
    },
};
</script>
